export default __webpack_public_path__ + "static/media/Montserrat-Medium.aa9fe98b.woff";